export default __webpack_public_path__ + "23c664384b223cbca7a2d5a30e641842.png";